/**
 * User-facing billing copy. Pass-through Twilio/carrier costs are invoice line items —
 * only SMS segments use Stripe metered usage (Meter Events API).
 */
export const PASS_THROUGH_COSTS = [
  'SMS usage — metered per segment, billed on your monthly Stripe invoice',
  'A2P registration — one-time $20 charged immediately when you submit AI Compliance',
  'Phone number — $1.15 charged immediately when assigned, then each billing cycle',
];

export const BILLING_SUMMARY =
  '$297 / month platform fee. SMS is metered monthly; A2P and phone fees are charged immediately when incurred.';

/** Shown before the user submits AI Compliance (charge fires on submit). */
export const A2P_CHARGE_AT_SUBMIT =
  'By submitting, a one-time $20 carrier registration fee (brand + campaign) will be charged immediately to your payment method on file.';

/** Shown after AI Compliance is submitted successfully. */
export const A2P_CHARGE_CONFIRMED =
  'A $20 carrier registration fee has been charged to your payment method on file.';

/** Shown when a phone number is assigned or about to be assigned. */
export const PHONE_CHARGE_WHEN_ASSIGNED =
  'A $1.15/month phone rental fee will be charged immediately when your number is assigned, then on each billing cycle.';
